import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

import { Loading, Layout, LoadingLayout } from 'common/components/layout';
import { doesCustomerExist } from 'common/helpers/customerHelper';
import { retry } from 'common/helpers/routerHelper';

const LoadableComponent = lazy(() => retry(() => import('./App')));

const ProfileRoutes = () => {
  const customer = useSelector((state) => state.customer.data);

  if (doesCustomerExist()) {
    if (!customer) {
      return <LoadingLayout />;
    }
  }

  return (
    <Layout>
      <Suspense fallback={<Loading />}>
        <LoadableComponent />
      </Suspense>
    </Layout>
  );
};

export default ProfileRoutes;
